import React from 'react';
import { useLanguage } from './LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-svt-bg-deep py-8 border-t border-svt-border transition-colors duration-300" data-id="element-54">
      <div className="container mx-auto px-6" data-id="element-55">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-56">
          <a href="#" className="flex items-center gap-3" data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/x3zgz2YSJzc57ZhT1dBqrP/logo.png" alt="SVT Dating Logo" className="h-8 w-auto" data-id="element-58" />
            <span className="font-serif text-xl font-bold tracking-wide text-svt-text" data-id="element-59">
              SVT dating
            </span>
          </a>

          <p className="text-svt-text-faint text-sm" data-id="element-60">{t('footer.rights')}</p>
        </div>
      </div>
    </footer>;
}